export const numberWithDots = (text, float = false) => {
    if (text) {
        // float represent two digits after comma
        // if passed number like 123.24 with float: false it will be => 123
        return text.toFixed(float ? 2 : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    } else {
        return text
    }
}